import React, { CSSProperties, forwardRef, MouseEventHandler, PropsWithChildren } from "react";
import "./ClickableText.css";

export interface Props {
  id?: string;
  disabled?: boolean;
  icon?: React.ReactNode;
  color?: Colors;
  style?: CSSProperties;
  className?: string;
  title?: string | null;
  onClick?: MouseEventHandler;
  text?: string;
}

type Colors = "green" | "gray" | "red" | "orange" | "blue" | "whiteOnGreen" | "blackOnGrey";

export default forwardRef<HTMLButtonElement, PropsWithChildren<Props>>(function AClickableText(
  { id, disabled, icon, color, style, className, title, onClick, children, text },
  ref,
) {
  let colorClass = "gray";

  if (color) colorClass = `clickableText-${color}`;

  if (disabled) colorClass = "clickableText-disabled";

  return (
    <button
      ref={ref}
      id={id}
      className={`clickableText-button ${colorClass} ${className}`}
      style={style}
      title={title ?? undefined}
      onClick={onClick}
      disabled={disabled}
    >
      {icon}
      {text}
      {children}
    </button>
  );
});
